import { render, staticRenderFns } from "./ViAdmissionSettings.vue?vue&type=template&id=53eb6040"
import script from "./ViAdmissionSettings.vue?vue&type=script&lang=js"
export * from "./ViAdmissionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports